// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__aViSI","options":"AnswerScale_options__DttZS","selected":"AnswerScale_selected__26wlg"};